import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import SelectLoadMethodCard from './sections/SelectLoadMethodCard/SelectLoadMethodCard';
import BdsButton from '../../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import { EMAILS_ICON, UPLOAD_ICON } from '../../../../../shared/constants/images';
import {
  CLICK_ACTION,
  COLLABORATOR_UPLOAD_METHOD_CHOICE_DICT,
  INVITE_COLLABORATORS_METHOD
} from '../../../../../shared/constants/tagManager';
import TagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../../../../../shared/translations/manageCollaborators';
import { ManageCollaboratorsUploadMethods } from '../../../../../shared/types/types';
import './SelectLoadMethod.scss';

interface ISelectLoadMethod {
  nextStep: () => void;
  onUploadMethodSelected: (method: ManageCollaboratorsUploadMethods) => void;
  uploadMethod?: ManageCollaboratorsUploadMethods;
}

const SelectLoadMethod = ({ nextStep, onUploadMethodSelected, uploadMethod }: ISelectLoadMethod) => {
  const [disableButton, setDisableButton] = useState(true);
  const { t } = useTranslation();

  const loadOptions = [
    {
      icon: EMAILS_ICON,
      title: TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.selectUploadMethod.emailTitle,
      description: TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.selectUploadMethod.emailDescription,
      disclaimer: TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.selectUploadMethod.emailDisclaimer,
      value: 'upload-email' as ManageCollaboratorsUploadMethods
    },
    {
      icon: UPLOAD_ICON,
      title: TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.selectUploadMethod.fileTitle,
      description: TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.selectUploadMethod.fileDescription,
      disclaimer: TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.selectUploadMethod.fileDisclaimer,
      value: 'upload-file' as ManageCollaboratorsUploadMethods
    }
  ];

  const handleOnChangeMethodSelected = (v: ManageCollaboratorsUploadMethods) => {
    onUploadMethodSelected(v);
  };

  const handleButtonClick = () => {
    const method = uploadMethod === 'upload-email' ? 'uploadByEmail' : 'uploadByFile';
    TagManagerService.pushEvent(
      CLICK_ACTION,
      INVITE_COLLABORATORS_METHOD,
      COLLABORATOR_UPLOAD_METHOD_CHOICE_DICT[method]
    );
    nextStep();
  };

  useEffect(() => {
    if (uploadMethod) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [uploadMethod]);

  return (
    <>
      <div className="c-select-load-method">
        {loadOptions.map((option) => (
          <SelectLoadMethodCard
            key={option.value}
            pictogram={{ component: option.icon }}
            title={t(option.title, { count: 2 })}
            description={t(option.description)}
            disclaimer={t(option.disclaimer)}
            selected={uploadMethod === option.value}
            onClick={() => handleOnChangeMethodSelected(option.value)}
          />
        ))}
      </div>
      <div className="upload-collaborators-button flex flex-row justify-end">
        <BdsButton variant="primary" size="l" action={handleButtonClick} disabled={disableButton}>
          {t(TRANSLATION_MANAGE_COLLABORATORS.buttonNext)}
        </BdsButton>
      </div>
    </>
  );
};

export default SelectLoadMethod;
